export default __webpack_public_path__ + "static/media/foxes.34a6d3ea.gif";